export default "__VITE_ASSET__3b84017f__"